// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import ErrorText from '../controls/ErrorText'
import Button from '../controls/PrimaryButton'
import type { OptionType } from '../types'

const InputGroup: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-bottom: 12px;
`
const Label: StyledComponent<Object, any, any> = styled.div`
  padding: 3px 0;
  font-size: 12px;
  color: gray;
`
const TextInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
  ${({ hasErrors }) => hasErrors && 'border-color: red;'};
`

type CommonProps = {|
  disabled: boolean
|}

type InputCommonProps = {|
  inputGroupClassName: string,
  label: string,
  errors?: Array<string>,
  value: string,
  onChange: Function
|}

type SelectProps = {|
  options: Array<OptionType>,
  ...CommonProps,
  ...InputCommonProps
|}

type TextInputProps = {|
  className?: string,
  ...CommonProps,
  ...InputCommonProps
|}

type ButtonProps = {|
  buttonText: string,
  className?: string,
  onClick: Function,
  ...CommonProps
|}

export class SelectItem extends Component<SelectProps> {
  render() {
    const { inputGroupClassName, label, errors, value, options, disabled, onChange } = this.props
    return (
      <InputGroup className={inputGroupClassName}>
        <Label>{label}</Label>
        <Select value={value} options={options} disabled={disabled} onChange={onChange} />
        <ErrorText errors={errors} />
      </InputGroup>
    )
  }
}

export class TextInputItem extends Component<TextInputProps> {
  render() {
    const { inputGroupClassName, label, errors, className, value, disabled, onChange } = this.props
    return (
      <InputGroup className={inputGroupClassName}>
        <Label>{label}</Label>
        <TextInput className={className} value={value} disabled={disabled} onChange={onChange} />
        <ErrorText errors={errors} />
      </InputGroup>
    )
  }
}

export class ButtonItem extends Component<ButtonProps> {
  render() {
    const { buttonText, className, onClick, disabled } = this.props
    return (
      <Button className={className} disabled={disabled} onClick={onClick}>
        {buttonText}
      </Button>
    )
  }
}
